import { render, staticRenderFns } from "./EditorTextEditor.vue?vue&type=template&id=6b1f1777&scoped=true&"
import script from "./EditorTextEditor.vue?vue&type=script&lang=js&"
export * from "./EditorTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./EditorTextEditor.vue?vue&type=style&index=0&id=6b1f1777&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1f1777",
  null
  
)

export default component.exports